module.exports = __webpack_public_path__ + "03_bob_beige.3ea2e959.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/03_bob_beige.png
// module id = wTav
// module chunks = 0